import React, { useState } from "react";
import { Table, Pagination, Dropdown, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import "../../../../pages/Tickets/Tickets.scss";
import "../ServiceRequestList/style.scss";
import DrawerLayout from "../..";
import { EyeIcon } from "../../../../icons";
import Button from "../../../button";
import Input from "../../../form/input";
import ServiceDetailsModal from "../../../ModalLayout/components/ServiceDetailmodal";


const STATUS_CLASS_MAP: { [key: string]: string } = {
  Resolved: "status-resolved",
  New: "status-new",
  Initiated: "status-initiated",
  Closed: "status-closed",
  "Not Initiated": "status-not-initiated",
  Parked: "status-parked",
  Pending: "status-pending",
  Active: "status-active",
};

const STATUS_LABEL_MAP = {
  1: "Active",
  0: "Pending",
  23: "Rejected",
  31: "Parked",
};


interface ContractServicesDrawerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  pikitupServices: any[];
  pikitupMeta: any;
}

const ContractServicesDrawer: React.FC<ContractServicesDrawerProps> = ({
  open,
  setOpen,
  pikitupServices,
  pikitupMeta
}) => {
  const [currentPage, setCurrentPage] = useState(pikitupMeta?.current_page || 1);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  const handleViewService = (record: any) => {
    setSelectedRecord(record);
    setDetailsModalOpen(true);
  };


  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const total = pikitupMeta?.total || 0;
  const pageSize = pikitupMeta?.per_page || 10;
  const lastPage = pikitupMeta?.last_page || 1;


  const getActionMenu = (record: any) => (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <span
              className="flex justify-start items-center"
              onClick={() => handleViewService(record)}
            >
              <EyeIcon style={{ width: 16, height: 16, marginRight: 8 }} />
              View ticket
            </span>
          ),
        },
      ]}
    />
  );

  // Update the mapping to include all necessary fields
  const mappedServices = (pikitupServices ?? []).map((s: any, index: number) => {
    // Fix typo: "Acive" → "Active"
    const statusFromApi = s.status === "Acive" ? "Active" : s.status;
    const statusLabel = STATUS_LABEL_MAP[statusFromApi] || statusFromApi || "Pending";

    return {
      key: index + 1,
      serviceRef: s.service_reference_no || "-",
      serviceName: s.service || "-",
      productName: s.service || "-", // Add this for the modal
      qty: s.Qty || 0,
      serviceType: s.service_type || "-",
      status: statusLabel,
      installationDate: s.installation_date || "-",
      binDetails: s.bin_details || [],
      // Add other fields that might be needed
      accountNo: s.account_no,
    };
  });



  const columns = [
    {
      title: "Service Ref no.",
      dataIndex: "serviceRef",
      key: "serviceRef",
      width: 130,
      render: (text: string, record: any) => (
        <span
          className="cursor-pointer "
          onClick={() => handleViewService(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Service",
      dataIndex: "serviceName",
      key: "serviceName",
      width: 130,
      ellipsis: true,
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      align: "center" as const,
      width: 80,
    },
    {
      title: "Service type",
      dataIndex: "serviceType",
      key: "serviceType",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => (
        <span
          className={`status-pill ${STATUS_CLASS_MAP[record.status] || ""}`}
        >
          {record.status}
        </span>
      ),
    },
    {
      title: "Installation date",
      dataIndex: "installationDate",
      key: "installationDate",
      ellipsis: true,
    },
    {
      title: "Delivered date & time",
      dataIndex: "installationDate",
      key: "installationDate",
      ellipsis: true,
    },
    {
      title: "",
      key: "actions",
      width: 50,
      render: (_: any, record: any) => (
        <Dropdown overlay={getActionMenu(record)} trigger={["click"]}>
          <Button icon={<MoreOutlined />} type="text" />
        </Dropdown>
      ),
    },
  ];

  return (
    <DrawerLayout
      open={open}
      setOpen={setOpen}
      title="Pickitup services lists"
      width={800}
      placement="right"
      closable
      footer={false}
      className="service-request-drawer"
    >
      <div className="tickets-table-header-container">
        <div className="tickets-header flex items-center gap-4">
          <div className="services-header">
            <Input placeholder="Search..." className="services-search-input" />

            <button className="service-type ">ServiceType: All</button>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={mappedServices}
          pagination={false}
          bordered={false}
          rowKey="key"
          className="custom-service-request-table"
          scroll={{ x: "max-content" }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 16,
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 400, color: "#1E1E1E" }}>
            Page{" "}
            <input
              type="number"
              value={currentPage}
              min={1}
              max={10}
              onChange={(e) => setCurrentPage(Number(e.target.value))}
              style={{
                width: 40,
                padding: "2px 6px",
                border: "1px solid #ddd",
                borderRadius: 4,
                marginRight: 8,
              }}
            />
            of 10
          </div>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
        <ServiceDetailsModal
          open={detailsModalOpen}
          onClose={() => setDetailsModalOpen(false)}
          record={selectedRecord}
        />
      </div>
    </DrawerLayout>
  );
};

export default ContractServicesDrawer;
